var $4cd8d8b72a119260$exports = {};
$4cd8d8b72a119260$exports = {
  "backButton": args => "\u041D\u0430\u0437\u0430\u0434 \u043A\u044A\u043C ".concat(args.prevMenuButton),
  "moreActions": "\u041F\u043E\u0432\u0435\u0447\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F",
  "unavailable": "\u041D\u0435\u0434\u043E\u0441\u0442\u044A\u043F\u043D\u043E, \u0440\u0430\u0437\u0433\u044A\u043D\u0435\u0442\u0435 \u0437\u0430 \u043F\u043E\u0434\u0440\u043E\u0431\u043D\u043E\u0441\u0442\u0438"
};
export { $4cd8d8b72a119260$exports as default };